import { PosterListPage } from "@/features/poster/pages/PosterListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/poster/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["poster.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: PosterListPage,
});
